export default "__VITE_ASSET__a3883ec8__"